import React from 'react';
import Form from 'react-bootstrap/Form';
import { Row } from 'react-bootstrap';

import SetupDepartmentTable from '../../../components/v2/SetupDepartmentTable';

export default function SetupStep1(props) {
    let department;
    let departmentId;

    if (props.departmentId && props.departments) {
        department = props.departments.find((d) => d.departmentId == props.departmentId)
        departmentId = props.departmentId
    } else if (props.department && props.departments) {
        department = props.departments.find((d) => d.departmentId == props.department.departmentId)
        departmentId = props.department.departmentId
    }

    let departmentPrograms = []

    department?.programList.forEach((program) => {
        if (program.active) {
            departmentPrograms.push({
                programId: program.programId,
                label: program.longName,
                isActive: program.programId in props.activePrograms ? props.activePrograms[program.programId] : 'no'
            })
        }
    })
    
    return (
        <div className="p-5 pb-md-4 mx-auto">
            <div className="p-1 text-center">
                <h3>Identify Programs to Assess</h3>
                <p className="fs-6 text-muted" style={{"textIndent":"50px"}}>
                    For each program (each degree, certificate and gen ed area)
                    being assessed, a mapping of learning outcomes to Universal
                    Themes must be set up first. Choose programs to set up by
                    selecting 'Yes' in the boxes below. Programs left with a 'No'
                    response can be thought of as either falling under a different
                    coordinator's authority or pending set up in the future.
                </p>
            </div>

            <div className="text-center">
                <Form.Group as={Row} className="m-3" controlId="dept-select">
                    <Form.Label column="lg" sm="4">
                        Department
                    </Form.Label>
                    <Form.Label column="lg" sm="8"
                        className="text-muted">
                        { department?.longName }
                    </Form.Label>
                </Form.Group>
            </div>

            <SetupDepartmentTable 
                mode={props.mode}
                departmentId={departmentId}
                department={department}
                departmentPrograms={departmentPrograms}
                onThemeChanged={props.onThemeChanged}
                activePrograms={props.activePrograms}
                setup={props.setup}
                programAssessmentsCreated={props.programAssessmentsCreated}
                departmentLearningOutcomes={props.departmentLearningOutcomes}
                />

            {props.programAssessmentsCreated && Object.keys(props.programAssessmentsCreated).length > 0
                ? <div className="text-center">
                    <p className="text-muted fs-6">
                    One or more programs have an existing Assessment saved. Modification of these mapping is no longer allowed.
                    </p>
                </div>
                : <></>

            }
        </div>
    )
}